// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"25a7284f","531":"9f0a38cb"}[chunkId] + ".css";
};